module.exports = __webpack_public_path__ + "img/tec.82be7c71.png";